<template>
    <div class="px-3 mt-4">
        <div class="mt-3 mb-8 space-y-2 max-w-7xl mx-auto">
            <p class="text-lg text-center font-medium">Invite Detail</p>
            <div v-if="loading" class="loading apollo">Loading...</div>

            <div v-else-if="error" class="bg-red-100 text-red-900 max-w-3xl overflow-auto">
                <pre><code>{{ JSON.stringify(error, null, 1) }}</code></pre>
            </div>

            <div v-else-if="code" class="result apollo">
                <a
                    class="px-5 py-3 font-bold bg-blue-600 text-white rounded-full hover:text-blue-100 mb-5 inline-block"
                    :href="data.passwordResetLink"
                    >Password Reset Link</a
                >
                <pre><code>{{ JSON.stringify(data, null, 1) }}</code></pre>
            </div>

            <!-- No result -->
            <div v-else class="no-result apollo">No result :(</div>
        </div>
    </div>
</template>
<script>
import api from '../lib/api'
export default {
    data() {
        return {
            loading: true,
            code: this.$route.params.code,
            data: null,
            error: null,
        }
    },
    async mounted() {
        try {
            this.data = await api.getInvite(this.code)
            this.loading = false
        } catch (err) {
            this.err = err
        }
    },
}
</script>
